const UNREAD_TITLE_PREFIX_PATTERN = /^\((?:\d+|99\+)\)\s+/;

export function formatUnreadDocumentTitlePrefix(unreadCount: number): string {
  if (unreadCount <= 0) {
    return "";
  }

  const label = unreadCount > 99 ? "99+" : String(unreadCount);
  return `(${label}) `;
}

export function stripUnreadDocumentTitlePrefix(title: string): string {
  return title.replace(UNREAD_TITLE_PREFIX_PATTERN, "");
}

export function applyUnreadCountToDocumentTitle(unreadCount: number | undefined): void {
  if (typeof document === "undefined") {
    return;
  }

  const baseTitle = stripUnreadDocumentTitlePrefix(document.title);
  if (typeof unreadCount !== "number") {
    if (document.title !== baseTitle) {
      document.title = baseTitle;
    }
    return;
  }

  const prefix = formatUnreadDocumentTitlePrefix(unreadCount);
  const nextTitle = `${prefix}${baseTitle}`;
  if (document.title !== nextTitle) {
    document.title = nextTitle;
  }
}
